<template>
  <div class="px-20 px-sm-30">
    <div class="new-container mx-auto">
      <template v-if="mySims">
        <div v-if="emptyType === 'referral' && mySims.length" class="new-container mx-auto mt-20 display-lg-none">
          <ReferralBanner />
        </div>

        <div class="sim-list d-grid gap-30 store-grid-cols-1 store-grid-cols-sm-2 store-grid-cols-md-3 py-30 py-sm-40">
          <div v-for="(eSim, index) in mySims" :key="`my-esim-item-${index}`">
            <sim
              type="my-esims"
              :item="eSim"
              :list-type="eSim.operator.type === 'local' ? 'local-packages' : 'global'"
              :country="eSim.operator.country"
              from="my-esims"
              :is-loading="eSim.dataUsageLoader"
              :usage-data="eSim.dataUsage"
              @onOpenSupportedCountries="onOpenSupportedCountries"
              :show-renewals="showRenewals"
            />
          </div>

          <client-only>
            <supported-countries-modal
              :modal-view="modals.supportedCountries.model"
              :countries="modals.supportedCountries.countries"
              :title="$t('components.supported.countries.modal.available-countries-title')"
              :search-input-placeholder="$t('placeholder.supported.countries.modal.available-countries-search')"
              :empty-text="$t('global.no-country-available')"
              @onCloseSupportedCountriesModal="onCloseSupportedCountries"
            />
          </client-only>
        </div>

        <div class="w-100" v-if="!emptyViewWait">
          <buy-new-esim />
        </div>
      </template>

      <template v-else>
        <template v-if="!emptyViewWait">
          <empty-view :type="emptyType" page="current" />
        </template>

        <template v-else>
          <div style="min-height: 50vh">
            <client-only>
              <v-lottie position="fixed" />
            </client-only>
          </div>
        </template>
      </template>
    </div>

    <KycVerifyModalWrapper />
    <KycDetailModal />
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import myEsimsMixin from '~/mixins/my-esims'
  import KycDetailModal from '~/components/shared/ekyc-detail-modal.vue'
  import KycVerifyModalWrapper from '~/components/shared/kyc-verify-modal/wrapper.vue'

  export default {
    name: 'my-esims-index',
    scrollToTop: true,
    mixins: [myEsimsMixin('normal')],
    components: {
      KycDetailModal,
      KycVerifyModalWrapper,
      BuyNewEsim: () => import('~/components/my-esims/buy-new-esim'),
    },
    async mounted() {
      if (this.$featureFlag.isActive('enable_corporate_mode')) {
        await this.fetchUserIdentities()
      }
    },
    methods: {
      ...mapActions({
        fetchUserIdentities: 'eKyc/fetch_user_identities',
      }),
    },
  }
</script>
